import axios from 'axios';

const DEFAULT_COUNTRY_ID = 4; // Турция
let SITE_HOST = `https://www.geograftour.com`;
const hostName = window.location.hostname;

if (hostName === '127.0.0.1' || hostName === 'localhost') {
  SITE_HOST = `http://127.0.0.1:8000`;
}

const geograftourAPI = {
  async getFact(countryId = DEFAULT_COUNTRY_ID) {
    const url = `${SITE_HOST}/api/dict/fact/${countryId}/`;
    const response = await axios.get(url);
    return response.data;
  },
  async getHotelsWithReviews(country = '') {
    const url = `${SITE_HOST}/api/hotels/${country}?our_comments=true`;
    const response = await axios.get(url);
    return response.data;
  },
  async getHotelInfo(country, hotelId) {
    const url = `${SITE_HOST}/api/hotels/${country}/hotel/${hotelId}`;
    const response = await axios.get(url);
    return response.data;
  },
};

export default geograftourAPI;
